module.exports = __webpack_public_path__ + "static/media/rain.7d065507.svg";